import { observable, action } from 'mobx'
import PaymentApi from 'api/PaymentApi'

class PaymentStore {
  @observable plans = []

  @observable isFetchingPlans = true

  @action
  async fetchPlans () {
    if (this.plans.length) return
    this.isFetchingPlans = true
    const { success, data } = await PaymentApi.getPlans()
    if (success) {
      // console.log('Plans', data)
      this.plans = data
    }
    this.isFetchingPlans = false
  }
}

export default PaymentStore
